import React, { useState, useEffect, useRef } from 'react';
import { FaSmile, FaTimes } from 'react-icons/fa';
import '../../css/Chat.css';

const EmojiPicker = ({ onEmojiSelect, onClose, isOpen, position = 'bottom' }) => {
  const [selectedCategory, setSelectedCategory] = useState('smileys');
  const emojiPickerRef = useRef(null);

  const emojiCategories = {
    smileys: [
      '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇',
      '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚',
      '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩',
      '🥳', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣',
      '😖', '😫', '😩', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬'
    ],
    gestures: [
      '👋', '🤚', '🖐️', '✋', '🖖', '👌', '🤌', '🤏', '✌️', '🤞',
      '🤟', '🤘', '🤙', '👈', '👉', '👆', '🖕', '👇', '☝️', '👍',
      '👎', '👊', '✊', '🤛', '🤜', '👏', '🙌', '👐', '🤲', '🤝',
      '🙏', '✍️', '💪', '🦾', '🦿', '🦵', '🦶', '👂', '🦻', '👃',
      '🧠', '🫀', '🫁', '🦷', '🦴', '👀', '👁️', '👅', '👄', '💋'
    ],
    objects: [
      '💎', '💍', '💐', '🌹', '🥀', '🌷', '🌻', '🌼', '🌸', '🌺',
      '🌻', '🌼', '🌽', '🌾', '🌿', '☘️', '🍀', '🍁', '🍂', '🍃',
      '🎄', '🎋', '🎍', '🎎', '🎏', '🎐', '🎀', '🎁', '🎗️', '🎟️',
      '🎫', '🎖️', '🏆', '🏅', '🥇', '🥈', '🥉', '⚽', '⚾', '🥎',
      '🏀', '🏈', '🏉', '🎾', '🎯', '🎳', '🎮', '🎲', '🧩', '🎨'
    ],
    symbols: [
      '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔',
      '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '☮️',
      '✝️', '☪️', '🕉️', '☸️', '✡️', '🔯', '🕎', '☯️', '☦️', '🛐',
      '⛎', '♈', '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐',
      '♑', '♒', '♓', '🆔', '⚛️', '🉑', '☢️', '☣️', '📴', '📳'
    ]
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  // Emoji kiválasztása
  const handleEmojiClick = (emoji) => {
    onEmojiSelect(emoji);

  };

  if (!isOpen) return null;

  return (
    <div className={`emoji-picker-container ${position === 'top' ? 'emoji-picker-top' : 'emoji-picker-bottom'}`}>
      <div className="emoji-picker-dropdown" ref={emojiPickerRef}>
        {/* Fejléc */}
        <div className="emoji-picker-header">
          <h3>Emojik</h3>
        </div>

        {/* Kategória választó */}
        <div className="emoji-categories">
          {Object.keys(emojiCategories).map((category) => (
            <button
              key={category}
              className={`emoji-category ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
              title={category === 'smileys' ? 'Hangulatjelek' : 
                     category === 'gestures' ? 'Gesztusok' :
                     category === 'objects' ? 'Tárgyak' : 'Szimbólumok'}
            >
              {emojiCategories[category][0]}
            </button>
          ))}
        </div>

        {/* Emoji lista */}
        <div className="emoji-list">
          {emojiCategories[selectedCategory].map((emoji, index) => (
            <button
              key={`${selectedCategory}-${index}`}
              className="emoji-item"
              onClick={() => handleEmojiClick(emoji)}
              title={emoji}
            >
              {emoji}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmojiPicker;
